import { render, staticRenderFns } from "./NewDocumentFormatSelectView.vue?vue&type=template&id=06977762&scoped=true&"
import script from "./NewDocumentFormatSelectView.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentFormatSelectView.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentFormatSelectView.vue?vue&type=style&index=0&id=06977762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06977762",
  null
  
)

export default component.exports